import { useState, useMemo } from 'react';
import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { useLayoutDimensions } from '@pletly/ui';
import { MediaSliderProps } from './types';

export const useMediaSlider = (images: MediaSliderProps['images']) => {
	const { navigate } = useNavigation();
	const { width, onLayout } = useLayoutDimensions();
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const media = useMemo(
		() => images.map(({ url, ...imageRest }) => ({ uri: url, ...imageRest })) || [],
		[images],
	);

	const onImagePress = (activeIndex: number) => {
		if (Platform.OS === 'web' && media[activeIndex].type === 'video') {
			return;
		}

		return navigate('FullScreenGallery', { currentIndex: activeIndex, media });
	};

	return {
		onLayout,
		width,
		onImagePress,
		media,
		currentImageIndex,
		setCurrentImageIndex,
	};
};
